module.exports = __webpack_public_path__ + "media/src/images/search_preview-ddf592d3babd35d52b83a2e229b1cb43.png";